import React, { memo } from 'react'

import PageHeading from '../../../components/shared/pageHeading/PageHeading'

const PageHeaderWrapper = (props) => {
  return <PageHeading {...props} />
}

export default memo(PageHeaderWrapper)
